import React from "react";

const BRANDS = [
  { name: "Blinkit", color: "#FFCB11" },
  { name: "Zepto", color: "#9D3CFF" },
  { name: "Swiggy", color: "#FC8019" },
  { name: "Swiggy Instamart", color: "#FC8019" },
  { name: "Zomato", color: "#E23744" },
  { name: "Uber Eats", color: "#06C167" },
  { name: "BigBasket", color: "#A5CD39" },
  { name: "BB Now", color: "#A5CD39" },
  { name: "JioMart", color: "#008ECC" },
  { name: "Swish", color: "#FF6B00" },
  { name: "Country Delight", color: "#E24B4A" },
  { name: "Licious", color: "#C03038" },
  { name: "FreshToHome", color: "#00A878" },
  { name: "Dunzo", color: "#00D3A7" },
];

/**
 * Endless marquee of supported food / grocery platform brands.
 * Duplicated inline so the loop is seamless.
 *
 * Props:
 *   light — light-theme variant used on the redesigned public Landing page.
 *           Chips render on a #F4FAF2 background with a green border and dark
 *           green name text. Default (false) preserves the original dark
 *           chip aesthetic used everywhere else.
 */
export default function ContinuousBrandStrip({ light = false }) {
  const doubled = [...BRANDS, ...BRANDS];
  const chipClass = light
    ? "px-3 py-1.5 bg-[#F4FAF2] border border-[#C0DD97] flex items-center gap-2 shrink-0 rounded-sm"
    : "px-3 py-1.5 bg-[#161620] border border-[#2A2A35] flex items-center gap-2 shrink-0";
  const nameClass = light
    ? "font-bold uppercase tracking-wider text-xs text-[#3B6D11]"
    : "font-bold uppercase tracking-wider text-xs";

  return (
    <div className="overflow-hidden" data-testid="continuous-brand-strip" aria-label="Supported food and grocery platforms">
      <div className="brand-strip-track flex gap-2 whitespace-nowrap py-1">
        {doubled.map((b, i) => (
          <div
            key={`${b.name}-${i}`}
            className={chipClass}
            data-testid={`brand-chip-${b.name.toLowerCase().replace(/\s+/g, "-")}-${i}`}
          >
            <span className="w-2 h-2 shrink-0" style={{ background: b.color }} />
            <span className={nameClass}>{b.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
